import renderHTML from 'react-render-html';
import AppBar from './components/AppBar';
import Footer from './components/Footer';

import './styles/Common.css';
import privacyHTML from './html/privacy_policy';
import JumboContainer from './components/common/JumboContainer';

function PrivacyPolicy() {
  return (
    <>
      <AppBar alwaysSolid />
      <JumboContainer white>
        {renderHTML(privacyHTML)}
      </JumboContainer>
      <Footer/>
    </>
  );
}

export default PrivacyPolicy;
